const SCORE_BADGE_SVG = `<svg width="124" height="125" viewBox="0 0 124 125" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M44.4051 25.7312L34.591 6.93084C18.2333 15.4886 6.20789 31.2426 2.76329 50.0417L24.1745 53.9902C26.0919 41.698 33.7919 31.3217 44.4051 25.7312Z" fill="#FFCC00"/>
<path d="M23.7083 60.0043C23.7083 57.9587 23.8679 55.9506 24.1735 53.9906L2.76329 50.0417C2.14718 53.4113 1.80167 56.8761 1.75982 60.4145C1.70336 65.3691 2.23772 70.1889 3.29573 74.8121L24.9697 69.8326C24.1463 66.694 23.7083 63.4016 23.7083 60.0043Z" fill="#F28D00"/>
<path d="M24.9687 69.8336L3.29573 74.8121C4.81801 81.4622 7.42844 87.7043 10.9314 93.339L30.1643 81.4145C27.8361 77.9137 26.0618 74.0119 24.9687 69.8336Z" fill="#F7A600"/>
<path d="M30.1643 81.4145L10.9314 93.339C13.7697 97.9067 17.1919 102.081 21.0988 105.743C10.5985 109.02 0 110.54 0 110.54C0.435077 110.957 12.3856 119.077 31.1464 122.961L45.5662 94.8654C39.3058 91.8329 33.9876 87.165 30.1643 81.4145Z" fill="#EA5A06"/>
<path d="M62.4106 98.7137C56.373 98.7137 50.6577 97.3333 45.5662 94.8654L31.1464 122.961C40.2898 124.854 51.0471 125.744 62.8788 124.243V98.7088C62.7231 98.7118 62.5673 98.7137 62.4106 98.7137Z" fill="#F7A600"/>
<path d="M62.8788 98.7088V124.243C68.4151 123.544 74.1869 122.318 80.1359 120.433L80.1261 120.392C85.4045 118.836 90.3908 116.554 94.9752 113.669L82.4329 93.1365C76.7156 96.6022 70.0308 98.6232 62.8788 98.7088Z" fill="#94C11C"/>
<path d="M101.114 60.0043C101.114 74.0538 93.631 86.355 82.4329 93.1365L94.9771 113.67C103.667 108.201 110.92 100.557 116.006 91.5321L116.037 91.4708C120.982 82.6635 123.873 72.5487 123.996 61.8449C124.049 57.1772 123.578 52.629 122.64 48.2535L100.486 53.0275C100.897 55.2912 101.114 57.6238 101.114 60.0043Z" fill="#C8D400"/>
<path d="M63.5961 0.00423812C53.1329 -0.117742 43.2556 2.39819 34.591 6.93084L44.4051 25.7312C49.7827 22.9003 55.9088 21.2917 62.4106 21.2917C81.4041 21.2917 97.2012 34.9766 100.485 53.028L122.641 48.2539C116.788 20.9555 92.6849 0.341753 63.5961 0.00423812Z" fill="#E8E000"/>
</svg>`;

export { SCORE_BADGE_SVG };

export const reviewsStyles = `
  :host {
    --orange: #FF6600;
    --orange-light: #fff7ed;
    --green: #6ab04c;
    --green-dark: #4a8a2c;
    --yellow: #f59e0b;
    --red: #ef4444;
    --bg: #ffffff;
    --bg-soft: #f9fafb;
    --border: #e8e8e8;
    --text: #333333;
    --text-muted: #888888;
    --radius: 10px;
    --shadow: 0 2px 8px rgba(0,0,0,0.07);
    --gradient-bar: linear-gradient(90deg, #F7A600 0%, #FFCC00 20%, #C8D400 45%, #94C11C 70%, #6ab04c 100%);

    display: block;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: var(--text);
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  /* FA loaded via link in render */
  .fa, .fas, .far, .fab, .fa-solid, .fa-regular {
    font-family: 'Font Awesome 6 Free', 'Font Awesome 6 Brands';
  }

  .widget { max-width: 480px; }

  /* ── Collapsed bar ── */
  .collapsed-bar {
    display: flex; align-items: center; justify-content: space-between;
    background: var(--bg); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 10px 16px;
    box-shadow: var(--shadow); cursor: pointer;
    transition: box-shadow 0.2s, border-color 0.2s;
    gap: 12px;
  }
  .collapsed-bar:hover { border-color: var(--orange); box-shadow: 0 4px 16px rgba(255,102,0,0.12); }

  .collapsed-left { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; }

  .collapsed-badge { position: relative; width: 44px; height: 44px; flex-shrink: 0; }
  .collapsed-badge-svg { width: 44px; height: 44px; }
  .collapsed-badge-svg svg { width: 44px; height: 44px; }
  .collapsed-score {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.85rem; font-weight: 600;
    font-family: 'Inter', sans-serif; color: #333; line-height: 1;
  }

  .collapsed-info { flex: 1; min-width: 0; }
  .collapsed-count { font-size: 0.75rem; color: var(--text-muted); margin-bottom: 4px; }
  .collapsed-pros { display: flex; flex-wrap: wrap; gap: 5px; }
  .collapsed-pro-chip {
    display: inline-flex; align-items: center; gap: 4px;
    background: #f0fdf4; border: 1px solid #bbf7d0;
    border-radius: 12px; padding: 2px 8px;
    font-size: 0.72rem; color: var(--green-dark); font-weight: 600;
    white-space: nowrap;
  }
  .collapsed-pro-chip i { font-size: 0.65rem; }

  .collapsed-right { flex-shrink: 0; }
  .collapsed-cta {
    display: inline-flex; align-items: center; gap: 6px;
    background: var(--orange); color: white;
    border-radius: 8px; padding: 6px 14px;
    font-size: 0.8rem; font-weight: 600; white-space: nowrap;
  }

  /* ── Drawer overlay ── */
  .drawer-overlay {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: flex-end;
    animation: fadeInOverlay 0.2s ease;
  }
  @keyframes fadeInOverlay { from { opacity:0; } to { opacity:1; } }

  /* Mobile: slide up from bottom */
  .drawer {
    width: 100%; max-height: 75vh;
    background: var(--bg); border-radius: 20px 20px 0 0;
    display: flex; flex-direction: column;
    animation: slideUp 0.25s cubic-bezier(0.32,0.72,0,1);
    box-shadow: 0 -8px 40px rgba(0,0,0,0.2);
  }
  @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }

  /* Desktop: slide in from right */
  @media (min-width: 640px) {
    .drawer-overlay { align-items: stretch; justify-content: flex-end; }
    .drawer {
      width: 480px; max-height: 100%;
      border-radius: 0; border-left: 1px solid var(--border);
      animation: slideRight 0.25s cubic-bezier(0.32,0.72,0,1);
    }
    @keyframes slideRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
  }

  .drawer-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 16px 20px 12px; border-bottom: 1px solid var(--border);
    flex-shrink: 0;
  }
  .drawer-title { font-size: 1rem; font-weight: 700; }
  .drawer-close {
    width: 32px; height: 32px; border-radius: 50%;
    border: 1px solid var(--border); background: var(--bg-soft);
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    font-size: 0.9rem; color: var(--text-muted); transition: all 0.15s;
  }
  .drawer-close:hover { border-color: var(--orange); color: var(--orange); }

  .drawer-body {
    flex: 1; overflow-y: auto; padding: 16px 20px;
    -webkit-overflow-scrolling: touch;
  }

  .drawer-body .widget { max-width: 100%; }

  /* ── Card ── */
  .card {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 18px;
    box-shadow: var(--shadow);
    margin-bottom: 14px;
  }

  /* ── Overview / AI summary ── */
  .overview-title {
    font-size: 1rem; font-weight: 700;
    color: var(--orange); margin-bottom: 12px;
  }

  .sentiment-row {
    display: flex; align-items: center;
    justify-content: space-between;
    margin-bottom: 8px; font-size: 0.82rem; font-weight: 600;
  }
  .sentiment-bar-wrap {
    flex: 1; height: 8px; background: #e5e7eb;
    border-radius: 4px; margin: 0 10px; overflow: hidden;
  }
  .sentiment-bar-fill {
    height: 100%; border-radius: 4px;
    background: var(--gradient-bar);
  }
  .sentiment-pct { font-size: 0.82rem; font-weight: 700; color: var(--green); }

  .overview-text {
    font-size: 0.8rem; color: var(--text-muted);
    line-height: 1.6; margin-bottom: 12px;
  }

  .pros-label {
    font-size: 0.8rem; font-weight: 700;
    color: var(--orange); margin-bottom: 6px;
    display: flex; align-items: center; gap: 6px;
  }
  .pro-item {
    font-size: 0.8rem; color: var(--text);
    padding: 2px 0 2px 18px; position: relative;
  }
  .pro-item::before { content: '✓'; position: absolute; left: 0; color: var(--green); font-weight: 700; }
  .ai-source {
    font-size: 0.72rem; color: var(--text-muted);
    margin-top: 12px; display: flex; align-items: center; gap: 4px;
  }

  /* ── Score badge + distribution ── */
  .score-dist-row {
    display: flex; align-items: flex-start; gap: 16px;
  }
  .score-badge-wrap {
    flex-shrink: 0; display: flex;
    flex-direction: column; align-items: center; gap: 6px;
  }
  .score-badge-svg {
    position: relative; width: 80px; height: 80px;
  }
  .score-badge-svg svg { width: 80px; height: 80px; }
  .score-badge-number {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.4rem; font-weight: 600; color: #333; line-height: 1;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    letter-spacing: -0.5px;
  }
  .badge-stars { color: #f5c518; font-size: 0.85rem; }
  .badge-count { font-size: 0.72rem; color: var(--text-muted); text-align: center; line-height: 1.3; }

  /* ── Distribution ── */
  .dist-list { flex: 1; }
  .dist-row {
    display: flex; align-items: center;
    gap: 6px; margin-bottom: 4px; font-size: 0.78rem; cursor: pointer;
  }
  .dist-score { width: 12px; text-align: right; font-weight: 600; color: var(--text-muted); }
  .dist-bar-wrap { flex: 1; height: 7px; background: #e5e7eb; border-radius: 4px; overflow: hidden; }
  .dist-bar-fill { height: 100%; background: var(--orange); border-radius: 4px; }
  .dist-count { width: 28px; color: var(--text-muted); font-size: 0.72rem; text-align: right; }

  /* ── Q&A panel ── */
  .qa-card {
    background: var(--bg); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 16px;
    box-shadow: var(--shadow); margin-bottom: 14px;
  }
  .qa-header {
    display: flex; align-items: center;
    justify-content: space-between; margin-bottom: 12px;
  }
  .qa-title { font-weight: 700; font-size: 0.95rem; }
  .qa-score-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: var(--orange-light); border: 1px solid #ffedd5;
    border-radius: 20px; padding: 4px 12px; font-size: 0.82rem;
  }
  .qa-score-stars { color: #f5c518; font-size: 0.8rem; }
  .qa-score-num { font-weight: 700; }
  .qa-score-count { color: var(--text-muted); }
  .qa-score-check { color: var(--green); font-weight: 700; }

  .qa-chips { display: flex; flex-wrap: wrap; gap: 7px; margin-bottom: 12px; }
  .qa-chip {
    padding: 6px 14px; border: 1px solid var(--border);
    border-radius: 20px; background: white; font-size: 0.8rem;
    cursor: pointer; color: var(--text-muted); transition: all 0.15s;
    font-family: inherit;
  }
  .qa-chip:hover { border-color: var(--orange); color: var(--orange); }

  .qa-input-row { display: flex; gap: 8px; }
  .qa-input {
    flex: 1; padding: 10px 14px;
    border: 1px solid var(--border); border-radius: 8px;
    font-size: 0.88rem; font-family: inherit; color: var(--text);
    transition: border-color 0.15s;
  }
  .qa-input:focus { outline: none; border-color: var(--orange); }
  .qa-input::placeholder { color: #aaa; }
  .qa-btn {
    padding: 10px 20px; background: var(--orange); color: white;
    border: none; border-radius: 8px; font-size: 0.88rem;
    font-weight: 700; cursor: pointer; white-space: nowrap;
    font-family: inherit; transition: background 0.15s;
  }
  .qa-btn:hover { background: #e65c00; }
  .qa-btn:disabled { opacity: 0.6; cursor: not-allowed; }

  .qa-answer {
    margin-top: 12px; padding: 12px 14px;
    background: var(--bg-soft); border-radius: 8px;
    border-left: 3px solid var(--orange); font-size: 0.85rem;
    line-height: 1.6; color: var(--text);
    animation: fadeIn 0.2s ease;
  }
  .qa-answer-label {
    font-size: 0.72rem; font-weight: 700; color: var(--orange);
    margin-bottom: 6px; display: flex; align-items: center; gap: 4px;
  }
  .qa-error { color: var(--red); font-size: 0.82rem; margin-top: 8px; }
  .qa-spinner {
    display: inline-block; width: 14px; height: 14px;
    border: 2px solid #ffedd5; border-top-color: var(--orange);
    border-radius: 50%; animation: spin 0.7s linear infinite;
    margin-right: 6px; vertical-align: middle;
  }

  /* ── Topics ── */
  .topics-card {
    background: var(--bg); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 14px 16px;
    box-shadow: var(--shadow); margin-bottom: 14px;
  }
  .topics-title { font-weight: 700; font-size: 0.88rem; margin-bottom: 2px; }
  .topics-sub { font-size: 0.75rem; color: var(--text-muted); margin-bottom: 10px; }
  .topics-chips { display: flex; flex-wrap: wrap; gap: 7px; }
  .topic-chip {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 4px 10px; border: 1px solid var(--border);
    border-radius: 20px; background: white;
    font-size: 0.78rem; cursor: pointer; color: var(--text);
    transition: all 0.15s;
  }
  .topic-chip:hover { border-color: var(--orange); color: var(--orange); }
  .topic-chip.active { background: var(--orange); border-color: var(--orange); color: white; }
  .topic-count {
    background: rgba(0,0,0,0.1); border-radius: 10px;
    padding: 1px 5px; font-size: 0.7rem; font-weight: 600;
  }
  .topic-chip.active .topic-count { background: rgba(255,255,255,0.25); }

  /* ── Filters ── */
  .filters-bar {
    display: flex; align-items: center; gap: 8px;
    padding: 10px 14px; background: var(--bg);
    border: 1px solid var(--border); border-radius: var(--radius);
    margin-bottom: 14px; box-shadow: var(--shadow); flex-wrap: wrap;
  }
  .filters-label { font-weight: 600; font-size: 0.82rem; color: var(--text-muted); }
  .filter-stars { color: var(--orange); font-size: 0.85rem; }
  .filter-select {
    padding: 4px 8px; border: 1px solid var(--border);
    border-radius: 6px; font-size: 0.75rem; background: white;
    color: var(--text); font-family: inherit;
  }
  .filter-select:focus { outline: none; border-color: var(--orange); }
  .reset-btn {
    margin-left: auto; width: 28px; height: 28px;
    border-radius: 50%; border: 1px solid var(--border);
    background: white; cursor: pointer; font-size: 0.85rem;
    display: flex; align-items: center; justify-content: center;
    color: var(--text-muted); transition: all 0.15s;
  }
  .reset-btn:hover { border-color: var(--orange); color: var(--orange); }

  /* ── Review card ── */
  .review-card {
    background: var(--bg); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 16px;
    margin-bottom: 12px; box-shadow: var(--shadow);
    animation: fadeIn 0.2s ease;
  }
  @keyframes fadeIn { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }

  .review-top-row {
    display: flex; align-items: flex-start; gap: 12px; margin-bottom: 8px;
  }
  .review-score-circle {
    width: 42px; height: 42px; border-radius: 50%;
    background: linear-gradient(135deg, #8dc63f, #6ab04c);
    color: white; font-weight: 600; font-size: 1rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; box-shadow: 0 2px 6px rgba(106,176,76,0.4);
  }
  .review-score-circle.mid {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    box-shadow: 0 2px 6px rgba(245,158,11,0.4);
  }
  .review-score-circle.low {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    box-shadow: 0 2px 6px rgba(239,68,68,0.4);
  }

  .review-stars { color: #f5c518; font-size: 0.9rem; margin-bottom: 3px; }
  .review-title { font-weight: 700; font-size: 0.9rem; margin-bottom: 2px; }
  .review-text { font-size: 0.83rem; color: #555; line-height: 1.6; margin-bottom: 8px; }

  .verified-badge {
    display: inline-flex; align-items: center; gap: 5px;
    background: #f0fdf4; border: 1px solid #bbf7d0;
    border-radius: 6px; padding: 3px 8px;
    font-size: 0.72rem; color: var(--green-dark);
    font-weight: 600; margin-bottom: 8px;
  }

  .review-divider { border: none; border-top: 1px solid var(--border); margin: 10px 0; }

  .review-meta-row {
    display: flex; align-items: center; gap: 12px;
    font-size: 0.75rem; color: var(--text-muted); margin-bottom: 4px;
  }
  .review-author { font-size: 0.78rem; color: var(--text-muted); }

  .shop-reply {
    margin-top: 10px; padding: 10px 12px;
    background: #f9fafb; border-radius: 8px;
    font-size: 0.8rem; border-left: 3px solid var(--orange); color: var(--text);
  }
  .shop-reply-label {
    font-weight: 700; font-size: 0.75rem;
    color: var(--orange); margin-bottom: 3px;
    display: flex; align-items: center; gap: 5px;
  }

  /* ── Pagination ── */
  .pagination {
    display: flex; align-items: center;
    justify-content: center; gap: 6px; margin-top: 16px;
  }
  .page-btn {
    padding: 6px 11px; border: 1px solid var(--border);
    border-radius: 6px; background: white; cursor: pointer;
    font-size: 0.82rem; color: var(--text); transition: all 0.15s;
    font-family: inherit;
  }
  .page-btn:hover { border-color: var(--orange); color: var(--orange); }
  .page-btn.active { background: var(--orange); border-color: var(--orange); color: white; }
  .page-btn:disabled { opacity: 0.4; cursor: not-allowed; }

  /* ── Loading / error ── */
  .loading {
    display: flex; align-items: center; justify-content: center;
    gap: 10px; padding: 40px; color: var(--text-muted);
  }
  .spinner {
    width: 20px; height: 20px;
    border: 2px solid #ffedd5; border-top-color: var(--orange);
    border-radius: 50%; animation: spin 0.7s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  .error-msg {
    background: #fef2f2; color: #dc2626;
    padding: 12px 16px; border-radius: 8px; font-size: 0.85rem;
  }
  .empty-msg {
    text-align: center; padding: 30px;
    color: var(--text-muted); font-size: 0.9rem;
  }
`;
